<div>
    <form [formGroup]="formGroup()">
        <div class="content-block">
            @if(this.eventFormStore().uploadItems().length > 0) {
                <div class="left-block">
                    <div class="privacy-block">
                        <h2>{{ "event_steps.step_privacy.privacy_header" | translate }}</h2>
                        <p>
                            {{ 'event_steps.step_privacy.privacy_blur_privacy_protection' | translate }} <span [ngClass]="formGroup().controls.privacyEnabled.value ? 'green' : 'red'">{{ formGroup().controls.privacyEnabled.value  ? ('event_steps.step_privacy.privacy_blur_active'  | translate) : ('event_steps.step_privacy.privacy_blur_inactive'  | translate)}}</span>
                        </p>

                        <div class="blur-container">
                            @if (highImpactEvent()) {
                                <p class="subtext-privacy" [innerHTML]="'event_steps.step_privacy.privacy_blur_subtext' | translate"></p>
                            }
                            @else {
                                <p class="subtext-privacy" [innerHTML]="'event_steps.step_privacy.privacy_no_blur_subtext' | translate"></p>
                            }
                        </div>

                        <mat-form-field appearance="outline" class="size-xs">
                            <mat-select [(value)]="eventFormStore().automaticBlur">
                                <mat-option [value]="true"> {{ 'general.automatic' | translate }} </mat-option>
                                <mat-option [value]="false"> {{ 'event_steps.step_privacy.privacy_help_header' | translate }} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        @if (!eventFormStore().automaticBlur()) {
                            @if(highImpactEvent()) {
                                <p>
                                    {{ 'event_steps.step_privacy.privacy_help_blur_subtext' | translate }}
                                </p>
                            } @else {
                                <p>
                                    {{ 'event_steps.step_privacy.privacy_help_no_blur_subtext' | translate }}
                                </p>
                            }

                            <div class="checklist">
                                <h3>{{ 'event_steps.step_privacy.blur_checklist.title' | translate }}</h3>

                                <div class="privacy-checklist-list">
                                    <boolean-selector 
                                        [control]="formGroup().controls.helpFunctionForm.controls.victimsOrPersonsVisible"
                                        [question]="'event_steps.step_privacy.blur_checklist.items.0'"
                                        [tooltipText]="'event_steps.step_privacy.blur_checklist.tooltips.0'"
                                    />

                                    <boolean-selector 
                                        [control]="formGroup().controls.helpFunctionForm.controls.minorsVisible"
                                        [question]="'event_steps.step_privacy.blur_checklist.items.1'"
                                    />
                                
                                    <boolean-selector 
                                        [control]="formGroup().controls.helpFunctionForm.controls.emergencyRespondersOrBystandersWantExclusion"
                                        [question]="'event_steps.step_privacy.blur_checklist.items.2'"
                                    />

                                    <boolean-selector 
                                        [control]="formGroup().controls.helpFunctionForm.controls.suspectVisible"
                                        [question]="'event_steps.step_privacy.blur_checklist.items.3'"
                                        [tooltipText]="'event_steps.step_privacy.blur_checklist.tooltips.1'"
                                    />

                                    <boolean-selector 
                                        [control]="formGroup().controls.helpFunctionForm.controls.licensePlatesVisible"
                                        [question]="'event_steps.step_privacy.blur_checklist.items.4'"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            <div class="high-impact-block">
                <h2>{{ "event_steps.step_privacy.additional_questions_header" | translate }}</h2>
                <p>{{ "event_steps.step_privacy.additional_questions_description" | translate }}</p>

                <h3>
                    {{ "event_steps.step_privacy.heftigEvent_header" | translate }}
                    <button type="button" mat-icon-button color="primary"
                        [matTooltip]="'event_steps.step_privacy.heftigEven_info' | translate"
                        matTooltipClass="custom-tooltip"
                        matTooltipPosition="above"
                    >
                        <mat-icon>info_outline</mat-icon>
                    </button>
                </h3>
                <mat-form-field appearance="outline" class="size-xs">
                    <mat-select 
                        id="adultContent" 
                        [formControl]="this.formGroup().controls.highImpactEvent"
                        [placeholder]="'event_steps.step_privacy.heftigEvent_placeholder' | translate" 
                        required
                    >
                        <mat-option [value]="true"> {{ 'general.yes' | translate }} </mat-option>
                        <mat-option [value]="false"> {{ 'general.no' | translate }} </mat-option>
                    </mat-select>
                    <mat-error>{{
                        "event_steps.step_privacy.heftigEvent_validation" | translate
                        }}</mat-error>
                </mat-form-field>

                @if(formGroup().controls.highImpactEvent.value === true) {
                    <h3>
                        {{ "event_steps.step_privacy.hulpdiensten_header" | translate }}
                        <button type="button" mat-icon-button color="primary"
                            [matTooltip]="'event_steps.step_privacy.hulpdiensten_help' | translate"
                            matTooltipClass="custom-tooltip"
                            matTooltipPosition="above"
                        >
                            <mat-icon>info_outline</mat-icon>
                        </button>
                    </h3>
                    <mat-form-field appearance="outline" class="size-xs">
                        <mat-select 
                            id="emergencyServices" 
                            [formControl]="this.formGroup().controls.emergencyServicesPresent"
                            [placeholder]="'event_steps.step_privacy.hulpdiensten_placeholder' | translate" 
                            required
                        >
                            <mat-option [value]="true"> {{ 'general.yes' | translate }} </mat-option>
                            <mat-option [value]="false"> {{ 'general.no' | translate }} </mat-option>
                        </mat-select>
                        <mat-error>{{
                            "event_steps.step_privacy.hulpdiensten_validation" | translate
                            }}</mat-error>
                    </mat-form-field>
                    @if (formGroup().controls.emergencyServicesPresent.value === false) {
                        <h3 class="warning-hulpdiensten">
                            {{ "event_steps.step_privacy.hulpdiensten_warning" | translate }}
                        </h3>
                    }
                }
            </div>
        </div>
    </form>
</div>